import { computed, inject, input, output, signal } from '@angular/core';
import { AgentPromptListService } from 'AgentApp/ts/features/agent-prompt-list/services/agent-prompt-list.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { UtilsService } from 'Angular/services/core/utils.service';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { getFileIcon } from 'AgentApp/ts/utils/agent-file';
import { stripContextBlocks } from 'AgentApp/ts/utils/context-block';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
function AgentUserMessageComponent_Conditional_1_For_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13)(2, "div", 14)(3, "div", 15)(4, "div", 16);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 18);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const file_r1 = ctx.$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("name", file_r1.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(file_r1.fileName);
} }
function AgentUserMessageComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵrepeaterCreate(1, AgentUserMessageComponent_Conditional_1_For_2_Template, 8, 2, "div", 12, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.filesWithFileName());
} }
function AgentUserMessageComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 19);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "Prompt has been saved to\u00A0");
    i0.ɵɵelementStart(4, "a", 20);
    i0.ɵɵlistener("click", function AgentUserMessageComponent_Conditional_5_Template_a_click_4_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.promptLibraryClicked.emit($event)); });
    i0.ɵɵtext(5, "Prompt Library");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, ".");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("href", ctx_r1.promptLibraryUrl, i0.ɵɵsanitizeUrl);
} }
function AgentUserMessageComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
} }
function AgentUserMessageComponent_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 7);
} }
function AgentUserMessageComponent_Conditional_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 8);
} }
function AgentUserMessageComponent_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 9);
} }
export class AgentUserMessageComponent {
    constructor() {
        this.agentPromptListService = inject(AgentPromptListService);
        this.utilsService = inject(UtilsService);
        this.urlsService = inject(UrlsService);
        this.messageText = input.required(...(ngDevMode ? [{ debugName: "messageText" }] : []));
        this.displayText = computed(() => stripContextBlocks(this.messageText()), ...(ngDevMode ? [{ debugName: "displayText" }] : []));
        this.files = input([], ...(ngDevMode ? [{ debugName: "files" }] : []));
        this.filesWithFileName = computed(() => {
            const files = this.files();
            return files.map((file) => {
                const fileName = this.getFileName(file);
                return { ...file, fileName, icon: getFileIcon(fileName, file.attachment_mime_type) };
            });
        }, ...(ngDevMode ? [{ debugName: "filesWithFileName" }] : []));
        this.promptLibraryClicked = output();
        this.promptLibraryUrl = this.urlsService.getUrl(this.urlsService.AGENT.PAGE, undefined, {
            view: 'savedPrompts',
        });
        this.saving = signal(false, ...(ngDevMode ? [{ debugName: "saving" }] : []));
        // Flipped once the user saves this message this session; renders the filled bookmark.
        this.saved = signal(false, ...(ngDevMode ? [{ debugName: "saved" }] : []));
        // Transient checkmark shown for ~2s right after saving, before settling on the filled bookmark.
        this.showSavedCheck = signal(false, ...(ngDevMode ? [{ debugName: "showSavedCheck" }] : []));
        this.copied = signal(false, ...(ngDevMode ? [{ debugName: "copied" }] : []));
    }
    getFileName(file) {
        return file.attachment_url.split('/').pop() || file.attachment_url;
    }
    savePrompt() {
        if (this.saving() || this.saved()) {
            return;
        }
        this.saving.set(true);
        this.agentPromptListService.createAgentPrompt({ prompt: this.displayText() }).subscribe({
            next: () => {
                this.saving.set(false);
                this.saved.set(true);
                this.showSavedCheck.set(true);
                setTimeout(() => {
                    this.showSavedCheck.set(false);
                }, 2000);
            },
            error: () => {
                this.saving.set(false);
            },
        });
    }
    copyText() {
        const contentCopied = this.utilsService.copyToClipboard(this.displayText());
        if (contentCopied && !this.copied()) {
            this.copied.set(true);
            setTimeout(() => {
                this.copied.set(false);
            }, 1300);
        }
    }
}
AgentUserMessageComponent.ɵfac = function AgentUserMessageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentUserMessageComponent)(); };
AgentUserMessageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentUserMessageComponent, selectors: [["ycn-agent-user-message"]], inputs: { messageText: [1, "messageText"], files: [1, "files"] }, outputs: { promptLibraryClicked: "promptLibraryClicked" }, decls: 13, vars: 10, consts: [[1, "section-ai-request", "pl-20"], [1, "pt-10", "text-right"], [1, "text-large", "leading-aire", "mb-1", "text-prewrap", "text-right"], [1, "section-ai-request-actions", "d-flex", "align-items-center", "justify-content-end"], [1, "d-flex", "align-items-center", "text-small", "text-gray-30", "mr-1"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-xs", "btn-transparent", "btn-lightgray", 3, "click", "tooltipTitle", "tooltipPlacement", "disabled"], [1, "loader-spinner-context", "loader-xs"], ["ycnIcon", "", "name", "icon-check", "role", "img", 1, "text-blue-ada", "fill-current"], ["ycnIcon", "", "name", "icon-bookmark-filled", "role", "img", 1, "text-blue-ada", "fill-current"], ["ycnIcon", "", "name", "icon-bookmark", "role", "img"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-xs", "btn-transparent", "btn-lightgray", 3, "click", "tooltipTitle", "tooltipPlacement"], ["ycnIcon", "", "role", "img", 3, "name"], [1, "plate-container", "d-inline-flex"], [1, "plate", "plate-thin", "plate-noshadow", "plate-white"], [1, "plate-header", "width-full"], [1, "plate-title", "min-width-0"], [1, "plate-title-icon"], ["ycnIcon", "", 3, "name"], [1, "plate-title-name", "min-width-0", "text-ellipsis"], ["ycnIcon", "", "name", "icon-check", "role", "img", 1, "fill-current", "text-smallest", "mr-1"], [1, "ai-prompt-saved", "text-underline", "text-gray-30", 3, "click", "href"]], template: function AgentUserMessageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵconditionalCreate(1, AgentUserMessageComponent_Conditional_1_Template, 3, 0, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵconditionalCreate(5, AgentUserMessageComponent_Conditional_5_Template, 7, 1, "div", 4);
        i0.ɵɵelementStart(6, "button", 5);
        i0.ɵɵlistener("click", function AgentUserMessageComponent_Template_button_click_6_listener() { return ctx.savePrompt(); });
        i0.ɵɵconditionalCreate(7, AgentUserMessageComponent_Conditional_7_Template, 1, 0, "div", 6)(8, AgentUserMessageComponent_Conditional_8_Template, 1, 0, ":svg:svg", 7)(9, AgentUserMessageComponent_Conditional_9_Template, 1, 0, ":svg:svg", 8)(10, AgentUserMessageComponent_Conditional_10_Template, 1, 0, ":svg:svg", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "button", 10);
        i0.ɵɵlistener("click", function AgentUserMessageComponent_Template_button_click_11_listener() { return ctx.copyText(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(12, "svg", 11);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.filesWithFileName().length ? 1 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.displayText());
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.saved() ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("tooltipTitle", ctx.saved() ? "Saved prompt" : "Save prompt")("tooltipPlacement", "bottom")("disabled", ctx.saving() || ctx.saved());
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.saving() ? 7 : ctx.showSavedCheck() ? 8 : ctx.saved() ? 9 : 10);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("tooltipTitle", ctx.copied() ? "Copied!" : "Copy")("tooltipPlacement", "bottom");
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", ctx.copied() ? "icon-check" : "icon-copy");
    } }, dependencies: [IconModule, i1.IconDirective, TooltipModule, i2.TooltipDirective], encapsulation: 2, changeDetection: 0 });
